var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"component-cover",attrs:{"src":_vm.src,"alt":""},on:{"error":_vm.error}})
}
var staticRenderFns = []

export { render, staticRenderFns }